export default __webpack_public_path__ + "static/media/audited.dce98fad.svg";